import React from 'react'
import Layout from "../components/Layout"
import StyledHero from "../components/StyledHero"
import { graphql } from 'gatsby'
import SEO from "../components/SEO"

export const query = graphql`
query {
    blogBcg: file(relativePath: {eq: "loginportal.jpg"}) {
        childImageSharp {
            fluid(quality: 90, maxWidth: 4160) {
                ...GatsbyImageSharpFluid_withWebp
            }
        }
    }
}
`;

export default function login({ data }) {
    return (
        <Layout>
            <SEO title="Portal" description="Patient Portal" />
            <StyledHero img={data.blogBcg.childImageSharp.fluid} />
        </Layout>
    )
}
